import { State } from 'src/types'
import { thumbHook } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/thumbHook'
import { littleHook } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/littleHook'
import { laceDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/lace'
import { liningDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/liningDrawer'
import { backStyleDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/backStyleDrawer'
import { brandLabelDrawerForCatcherMitt } from 'src/features/gorilla/drawer/common/useCanvasHelper'
import { canvasResetter } from 'src/util/canvas'
import { catchFaceDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/catchFaceDrawer'
import { webDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/webDrawer'
import { fingerEmbroideryDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/fingerEmbroideryDrawer'
import { fingerGuardDrawer } from 'src/features/gorilla/drawer/catchermitt/rightThrow/back/fingerGuardDrawer'

export const gorillaCanvasCatcherMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  // リセット
  canvasResetter(ctx)

  // 裏革
  liningDrawer(ctx, state)

  // バックスタイル
  backStyleDrawer(ctx, state)

  // 捕球面側
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color)

  // 指カバー・指当て
  fingerGuardDrawer(ctx, state)

  // 親指、小指の刺繍
  fingerEmbroideryDrawer(ctx, state.embroideries)

  // ウェブ
  webDrawer(ctx, state)

  // 革紐
  laceDrawer(ctx, state.lace.color)

  // かけ紐
  thumbHook(ctx, state.thumbHook.color)
  littleHook(ctx, state.littleHook.color)

  // ブランドのラベル
  brandLabelDrawerForCatcherMitt(ctx, state, 'gorilla')
}
